import { Form } from "@/ui/Form";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { ParallaxHexagon } from "@/ui/ParallaxHexagon";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import bg_3 from "./bg_3.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "py-7",
  tagline,
  title,
  description,
  image,
  formId,
  reverse = false,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
  custom_submission_page_url,
}) {
  return (
    <div
      className={cn(className, classes.FormSideImage)}
      data-reverse={reverse}
      data-bs-theme={theme}
    >
      <ParallaxBackground anim="y1n:x0:z1" image={bg_1} floating={false} className={classes.bg_1} />
      {!reverse && <ParallaxBackground anim="y1:x2:z0" image={bg_2} className={classes.bg_2} />}
      <ParallaxBackground anim="y2:x0:z0" image={bg_3} floating={false} className={classes.bg_3} />
      <Container fluid="md">
        <Row className={cn({ "flex-row-reverse": reverse })}>
          <Col xs={12} md={6} className="position-relative">
            <ParallaxHexagon translateY={[0, -20]} className={classes.img}>
              <EditableImage path="image_1" src={image} size="496x425" alt="" />
            </ParallaxHexagon>
          </Col>
          <Col xs={12} md={6}>
            <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
              <span dangerouslySetInnerHTML={{ __html: tagline }} />
            </Tagline>
            <EditableText path="title" tag="h2" className="mb-4">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </EditableText>
            <EditableHtml path="description">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </EditableHtml>
            <Form
              formId={formId}
              submission_page_url={custom_submission_page_url}
              custom_submission_page_url={
                custom_submission_page_url ? custom_submission_page_url : false
              }
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
